
































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { scheduleFields } from '@/config/schedule-config';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcSelect from '@shared/components/forms/inputs/select/select.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import { Schedule, ScheduleErrorObject } from '@bookings/interfaces/schedule';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcScheduleSeasonInputList from './schedule-season-input-list.vue';
import ScheduleService, { useScheduleService } from '@bookings/services/schedule-service';
import { AxiosError } from 'axios';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-schedule-form',
  components: {
    BpcInput,
    BpcSelect,
    BpcEntitySelect,
    BpcSection,
    BpcDatePicker,
    BpcScheduleSeasonInputList,
  },
})
export default class ScheduleForm extends Vue {
  @Prop(Object) readonly value: Schedule;
  @Prop({
    type: [Number, null],
  })
  readonly scheduleId: number | null;

  loading = false;
  errorsObject: ScheduleErrorObject = {};
  srv: ScheduleService = null;

  get formModel() {
    return this.value;
  }

  set formModel(value: Schedule) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return scheduleFields;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get usingOnlineBookingV2() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME);
  }

  created() {
    this.srv = useScheduleService();
  }

  mounted() {
    this.getSchedule();
  }

  async getSchedule(scheduleId = null) {
    if (!this.scheduleId && !scheduleId) {
      this.formModel = {
        id: null,
        center_id: this.tenantId,
        code: '',
        name: '',
        status: 'active',
        type: 'calendar',
        schedule_seasons: [],
        online_booking_resources: [],
        online_booking_resources_v2: [],
        calendar_resources: [],
      };
      return;
    }
    this.loading = true;
    this.formModel = await this.srv.getSchedule(this.scheduleId);
    this.loading = false;
  }

  async saveEntity() {
    if (this.scheduleId) {
      await this.updateEntity();
    } else {
      await this.createEntity();
    }
  }

  async updateEntity() {
    this.$emit('saving-entity', true);
    try {
      const newSchedule = await this.srv.updateSchedule(this.scheduleId, this.formModel);
      this.$emit('saving-entity', false);
      this.$emit('entity-updated', newSchedule);
    } catch (e) {
      this.manageSaveErrors(e as AxiosError);
      this.$emit('saving-entity', false);
    }
  }

  async createEntity() {
    this.$emit('saving-entity', true);
    try {
      const newSchedule = await this.srv.createSchedule(this.formModel);
      this.$emit('saving-entity', false);
      this.$emit('entity-created', newSchedule);
    } catch (e) {
      this.manageSaveErrors(e as AxiosError);
      this.$emit('saving-entity', false);
    }
  }

  manageSaveErrors(error: AxiosError) {
    const errors = error?.response?.data?.errors || {};
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, { error: errors[key][0], state: false });
    });
  }
}
